<div class="background-split-layout h-full w-full">
    <!-- Loading bar -->
    <app-fuse-loading-bar></app-fuse-loading-bar>

    <!-- Navigation -->
    <div class="flex h-full w-full flex-row">
        <fuse-vertical-navigation
            [ngClass]="isScreenSmall ? '' : 'split-layout'"
            class="dark bg-black print:hidden"
            [mode]="isScreenSmall ? 'over' : 'side'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="!isScreenSmall">
            <ng-container fuseVerticalNavigationContentHeader>
                <div class="flex h-14 items-center sm:pl-5 sm:pt-6">
                    <img
                        class="w-30"
                        src="images/logo/logo-text-on-dark.svg"
                        alt="Logo image" />
                </div>
                <!-- <div class="h-8 bg-red-300">2A</div> -->
                <div class="my-6 ml-2 h-px bg-gray-700"></div>
            </ng-container>

            <ng-container fuseVerticalNavigationFooter>
                <div class="mb-4 flex flex-col px-3">
                    <button mat-menu-item (click)="signOut()" class="w-full">
                        <div class="flex flex-row items-center gap-3">
                            <mat-icon
                                [svgIcon]="'good-circle:log_out'"
                                class="text-red-400 icon-size-4"></mat-icon>
                            <span class="">
                                {{ 'common.navigation.logout' | transloco }}
                            </span>
                        </div>
                    </button>
                    <div
                        class="mt-4 flex w-full flex-row gap-2 text-xs font-light">
                        <a href="dashboard">
                            {{ 'common.navigation.legal' | transloco }}
                        </a>
                        |
                        <a href="dashboard">
                            {{ 'common.navigation.t&c' | transloco }}
                        </a>
                    </div>
                </div>
            </ng-container>
        </fuse-vertical-navigation>

        <!-- Wrapper -->
        <div class="flex w-full min-w-0 flex-auto flex-col md:p-2">
            <div
                class="flex w-full min-w-0 flex-auto flex-col bg-gc-white md:rounded-3xl">
                <!-- Header -->
                <div
                    class="relative z-49 flex h-16 w-full flex-0 items-center pl-6 pr-4 print:hidden">
                    <!-- Navigation toggle button -->
                    @if (isScreenSmall) {
                        <button
                            mat-icon-button
                            (click)="toggleNavigation('mainNavigation')">
                            <mat-icon
                                [svgIcon]="
                                    'heroicons_outline:bars-3'
                                "></mat-icon>
                        </button>
                    }

                    <div
                        class="relative w-full font-accent text-lg font-normal uppercase">
                        {{ title }}
                        <div
                            class="absolute flex w-full flex-row items-center gap-1 text-md">
                            @if (breadcrumbs && breadcrumbs.length >= 2) {
                                @for (
                                    bread of breadcrumbs;
                                    track i;
                                    let i = $index
                                ) {
                                    @if (i < breadcrumbs.length - 1) {
                                        @if (bread.path) {
                                            <span
                                                class="text-primary-500"
                                                [routerLink]="bread.path"
                                                [relativeTo]="_activatedRoute">
                                                {{ bread.title ?? '_' }}
                                            </span>
                                        } @else {
                                            <span class="text-primary-500">
                                                {{ bread.title ?? '_' }}
                                            </span>
                                        }
                                        <span class=""> / </span>
                                    } @else {
                                        {{ bread.title ?? '_' }}
                                    }
                                }
                            }
                        </div>
                    </div>

                    <!-- Components -->
                    <div class="flex items-center space-x-0.5 sm:space-x-2">
                        <app-company-profile-actions></app-company-profile-actions>
                        <!-- <app-notifications></app-notifications> -->
                        <!-- <app-languages></app-languages> -->
                        <app-user [showAvatar]="true"></app-user>
                    </div>
                </div>

                <!-- Content -->
                <div
                    class="flex h-full w-full flex-auto flex-col pt-0 md:p-2 md:pt-0">
                    <div
                        class="bg-card flex h-full w-full flex-auto flex-col overflow-hidden border p-4 md:rounded-b-[20px] md:rounded-t-xl">
                        @if (true) {
                            <router-outlet></router-outlet>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
